/* nr-fixes.js — eager first covers, preload next rows, failed-image fallback, about toggle, labels */
(function(){
  function markLoaded(img){var m=img.closest('.product-card__media');if(m)m.classList.add('nr-loaded');}
  function fail(img){
    if(img.dataset.nrRetry!=='1'){img.dataset.nrRetry='1';var s=img.currentSrc||img.src;img.removeAttribute('srcset');img.src=s+(s.indexOf('?')>-1?'&':'?')+'r=1';return;}
    var box=document.createElement('div');box.className='nr-img-failed';box.textContent='Cover coming soon';img.replaceWith(box);
  }
  function prep(root){
    var imgs=(root||document).querySelectorAll('.product-card__image--primary, .nr-sleeve img');
    imgs.forEach(function(img,i){
      if(img.dataset.nrPrep)return; img.dataset.nrPrep='1';
      if(i<8&&root===document){img.loading='eager';img.setAttribute('fetchpriority','high');}
      if(img.complete&&img.naturalWidth)markLoaded(img);
      img.addEventListener('load',function(){markLoaded(img)});
      img.addEventListener('error',function(){fail(img)});
    });
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){var im=e.target;if(im.loading==='lazy')im.loading='eager';io.unobserve(im);}})},{rootMargin:'900px 0px'});
      imgs.forEach(function(img){if(img.loading==='lazy')io.observe(img)});
    }
  }
  function labels(){
    document.querySelectorAll('.nr-shopping-paths a, a.button, .nr-card-status').forEach(function(a){
      if(/Preorder\s*·\s*save 15%/i.test(a.textContent)) a.innerHTML=a.innerHTML.replace(/Preorder\s*·\s*save 15%/i,'Order-in · save 15%');
    });
    if(document.querySelector('.nr-intro-links')) document.documentElement.classList.add('nr-has-intro-links');
  }
  function about(){
    var p=document.querySelector('.collection-description'); if(!p||p.dataset.nrAbout)return; p.dataset.nrAbout='1';
    var extra=[].filter.call(p.querySelectorAll(':scope > p'),function(x,i){return i>0&&!x.classList.contains('nr-intro-links')});
    if(!extra.length)return;
    var b=document.createElement('button');b.type='button';b.className='nr-about-toggle';b.textContent='About this collection';
    b.addEventListener('click',function(){var o=p.classList.toggle('nr-open');b.textContent=o?'Show less':'About this collection';});
    p.appendChild(b);
  }
  function slow(){var grid=document.querySelector('.product-list');if(!grid)return;var n=document.createElement('p');n.className='nr-loading-note';n.textContent='Loading records…';grid.parentNode.insertBefore(n,grid);var t=setTimeout(function(){document.documentElement.classList.add('nr-slow')},1500);window.addEventListener('load',function(){clearTimeout(t);document.documentElement.classList.remove('nr-slow')});}
  function run(){prep(document);labels();about();}
  if(document.readyState!=='loading'){run();slow();}else document.addEventListener('DOMContentLoaded',function(){run();slow();});
  new MutationObserver(function(ms){ms.forEach(function(m){m.addedNodes.forEach(function(n){if(n.nodeType===1){prep(n);}})})}).observe(document.documentElement,{childList:true,subtree:true});
})();
